import { controller, target, targets } from '@github/catalyst';
import { instantiateTemplate, synchronizePointers } from './editable-list';

@controller('swap-controller')
class SwapControllerElement extends HTMLElement {
  @target declare target: HTMLFormElement;
  @targets declare templates: HTMLTemplateElement[];
  @target declare secondaryTarget: HTMLFormElement;
  @targets declare secondaryTemplates: HTMLTemplateElement[];

  swap({ target }: Event) {
    const value =
      target && 'value' in target && typeof target.value === 'string'
        ? target.value
        : null;
    {
      const template = this.templates.find(
        t => t.getAttribute('data-value') === value
      );
      if (template) {
        const fragment = instantiateTemplate(template);
        const nodes = Array.from(fragment.children);
        const current = this.target;
        current.after(fragment);
        current.remove();
        nodes.forEach(synchronizePointers);
      }
    }
    {
      const template = this.secondaryTemplates.find(
        t => t.getAttribute('data-value') === value
      );
      if (template) {
        const fragment = instantiateTemplate(template);
        const nodes = Array.from(fragment.children);
        const current = this.secondaryTarget;
        current.after(fragment);
        current.remove();
        nodes.forEach(synchronizePointers);
      }
    }
  }
}

declare global {
  interface Window {
    SwapControllerElement: typeof SwapControllerElement;
  }
  interface HTMLElementTagNameMap {
    'swap-controller': SwapControllerElement;
  }
}
